/**
 * Two-Factor Authentication service
 */
import apiClient from './apiClient';

export const twoFactorService = {
  /**
   * Enable 2FA for user
   * @param {Object} data - 2FA configuration (method, security_questions)
   * @returns {Promise} Success message
   */
  enable: async (data) => {
    return apiClient.post('/two-factor/enable', data);
  },

  /**
   * Disable 2FA for user
   * @returns {Promise} Success message
   */
  disable: async () => {
    return apiClient.post('/two-factor/disable');
  },

  /**
   * Request OTP via email
   * @param {string} email - User email
   * @returns {Promise} Success message with expiry time
   */
  requestEmailOTP: async (email) => {
    return apiClient.post('/two-factor/send-email-otp', { email });
  },

  /**
   * Request OTP via SMS
   * @param {string} phone_number - User phone number
   * @returns {Promise} Success message with expiry time
   */
  requestSMSOTP: async (phone_number) => {
    return apiClient.post('/two-factor/send-sms-otp', { phone_number });
  },

  /**
   * Verify OTP
   * @param {string} email - User email
   * @param {string} otp - OTP code
   * @returns {Promise} Verification result
   */
  verifyOTP: async (email, otp) => {
    return apiClient.post('/two-factor/verify-otp', { email, otp });
  },

  /**
   * Setup security questions
   * @param {Array} questions - Array of {question_id, answer}
   * @returns {Promise} Success message
   */
  setupSecurityQuestions: async (questions) => {
    return apiClient.post('/two-factor/setup-security-questions', { questions });
  },

  /**
   * Verify security questions
   * @param {string} email - User email
   * @param {Array} answers - Array of {question_id, answer}
   * @returns {Promise} Verification result
   */
  verifySecurityQuestions: async (email, answers) => {
    return apiClient.post('/two-factor/verify-security-questions', { email, answers });
  },

  /**
   * Get user's security questions
   * @param {string} email - User email
   * @returns {Promise} List of security questions
   */
  getSecurityQuestions: async (email) => {
    return apiClient.get('/two-factor/security-questions', { email });
  }
};

export default twoFactorService;
